module.exports = __webpack_public_path__ + "img/intro_cn.392c9320.png";